import { hydrate } from 'react-dom';
import configureStore from './configureStore';
import { ReducersMapObject } from 'redux';
import { rootId, dehydratedState } from './lib/config';
import { renderView } from './renderView';
import { ViewStore } from './views';

declare global {
  interface Window {
    [key: string]: any;
  }
}

const getScriptState = (id: string) => {
  const elem = document.getElementById(id);

  if (!elem) {
    throw new Error(`Missing state to hydrate with: ${id}`);
  }

  return JSON.parse(elem.innerHTML);
};

const hydrateStore = (reducers: ReducersMapObject, namespace: string) =>
  configureStore(reducers, getScriptState(dehydratedState(namespace)));

const render = (View: any, { reducers }: ViewStore, namespace: string) =>
  hydrate(
    renderView(View, hydrateStore(reducers, namespace)),
    document.getElementById(rootId(namespace))
  );

export default render;
